import React from "react";
import { makeObservable, observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import apiService from "./services/apiService";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import Users from "./pages/Users";
import ClientError from "./pages/ClientError";

import './App.css';
import './components/ContextMenu/_context-menu.scss';
import SharedFile from "./pages/SharedFile";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import SharedSpace from "./pages/SharedSpace";

type UserData = { role: string; roles?: string[]; tokensLeft: number; picture?: string; name?: string; given_name?: string; family_name?: string; email: string; emailMd5: string; id: string };
declare global {
  interface Window {
    user?: UserData;
  }
}

@observer
class App extends React.Component {
  @observable UserData = window.user;
  @observable isLoading = true;

  constructor(props: {}) {
    super(props);
    makeObservable(this);
  }

  componentDidMount(): void {
    void this._checkUserLoggedIn();
  }

  render(){

    if (this.isLoading) {
      return null;
    }

    const isLoggedIn = !!window.user;
    return (
      <BrowserRouter>
        <ErrorBoundary fallback={(e) => <ClientError error={e} />}>
          <Routes>
            {!isLoggedIn ? (
              <>
                <Route
                  path="/file/download/:fileId"
                  element={
                    <SharedFile
                      fileId={
                        // Get fileId from URL using regexp
                        window.location.pathname.match(/\/file\/download\/([^\/]+)/)?.[1] || ""
                      }
                      directory={new URLSearchParams(window.location.search).get('directory') || undefined}
                    />
                  }
                />
                <Route
                  path="/f/:fileCustomName"
                  element={
                    <SharedFile
                      customName={window.location.pathname.match(/\/f\/([^\/]+)/)?.[1] || ""}
                      directory={new URLSearchParams(window.location.search).get('directory') || undefined}
                    />
                  }
                />
                <Route path="/" element={<LoginPage />} />
                <Route
                  path="/share-space/:token"
                  element={
                    <SharedSpace
                      token={window.location.pathname.match(/\/share-space\/([^\/]+)/)?.[1] || ""}
                    />
                  }
                />
                <Route path="*" element={<Page404 />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Home />} />
                <Route path="/trash" element={<Home />} />
                <Route path="/users" element={<Users />} />
                <Route
                  path="/share-space/:token"
                  element={
                    <SharedSpace
                      token={window.location.pathname.match(/\/share-space\/([^\/]+)/)?.[1] || ""}
                    />
                  }
                />
                <Route
                  path="/file/download/:fileId"
                  element={
                    <SharedFile
                      fileId={
                        // Get fileId from URL using regexp
                        window.location.pathname.match(/\/file\/download\/([^\/]+)/)?.[1] || ""
                      }
                      directory={new URLSearchParams(window.location.search).get('directory') || undefined}
                    />
                  }
                />
                <Route
                  path="/f/:fileCustomName"
                  element={
                    <SharedFile
                      customName={window.location.pathname.match(/\/f\/([^\/]+)/)?.[1] || ""}
                      directory={new URLSearchParams(window.location.search).get('directory') || undefined}
                    />
                  }
                />
                <Route path="*" element={<Page404 />} />
              </>
            )}
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    );
  }

  private async _checkUserLoggedIn() {
    const isLoggedIn = !!window.user;
    if (!isLoggedIn) {
      const userData = await apiService.get<{ isAuthenticated: boolean, user?: UserData }>('/auth/userinfo');
      if (userData.isAuthenticated && userData.user) {
        window.user = userData.user;
        this.UserData = userData.user;
      }
    }
    runInAction(() => {
      this.isLoading = false;
    });
  }

};

export default App;